<youtube-player id="my-video-container" 
  videoId="{{videoId}}" 
  [width]="width" 
  [height]="height" 
  (window:resize)="onResize($event)">
</youtube-player>